export const GENERIC_COMPOSITIONS_PREFIX = "@GENERIC_COMPOSITIONS/"
export const FETCH_GENERIC_COMPOSITIONS = `${GENERIC_COMPOSITIONS_PREFIX}FETCH_GENERIC_COMPOSITIONS`
export const FETCH_GENERIC_COMPOSITION = `${GENERIC_COMPOSITIONS_PREFIX}FETCH_GENERIC_COMPOSITION`
